import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
// import { insWords, applyComma, wordCapital } from "../../shared/functions"
import { insWords, applyComma, wordCapital, lineCapital, maskAlternateCharsInEmail } from "../../shared/functions"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import { isIE } from "react-device-detect"
import { JourneyContext } from "../context/journeyContext"
import * as lookup from "../../../static/lookup.json"
import { getValueFromJourney ,getValueFromLookup} from "../services/helperFunctions"
import { fetchDomain, ifscCodeDetails } from "../../services/apiservice"

const numToWordFormControlKey = [
  "AnnualIncome",
  "annualIncome",
  "spouseAnnualIncome",
  "sumAssured",
  "CPResidentAndOccupationExistingSumAssured",
  "riderSumAssured",
]
const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .str-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & input {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    line-height: 4;
    height: 42px;
    background: ${props =>
      props.channel === "A"
        ? "#ededed"
        : "#fff"};
    background: var(--lumiq-bg);
    ${isIE => {
      if (isIE) return `line-height: 3;`
    }}
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props =>
      props.channel === "A"
        ? "#ededed"
        : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`

export default function ComponentTextString(props) {
  // console.log(props,'799999999999999999999')
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext);
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [showIns, setShowIns] = useState(true)
  const [isSectionSetForFirstTime, setIsSectionSetForFirstTime] = useState(false);

  const validate = target => {
    if (props.data.required) {
      // required field validation
      if((journeyState.corpDiscOpt === "Y" && props.data.formControlKey === "corpEmail") && (sectionState.sectionData?.[props.data.formControlKey] === "" ||
        !sectionState.sectionData?.[props.data.formControlKey])){
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "Please enter corporate email address"
            }
          })
          return
        }
     else  if (
        sectionState.sectionData?.[props.data.formControlKey] === "" ||
        !sectionState.sectionData?.[props.data.formControlKey]
      ) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
              ? lineCapital(getValueFromLookup(
                "required_error",
                props.data.requiredError
              )) : `Error Code Not Found in Strapi`,
          }
        })
        return
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
    }
    if (target.value) {
      if (props.data.min_len) {
        // min_len validation
        if (target.value.length < props.data.min_len) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: `Minimum length should be ${props.data.min_len}`,
            }
          })
          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "",
            }
          })
        }
      }
      if (props.data.max_length) {
        //max length validation
        if (target.value.length > props.data.max_length) {
          if (props.data.label) {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: `${lineCapital(getValueFromLookup(
                    "label",
                    props.data.label
                  )) || props.data.label} can maximum be of ${props.data.max_length} characters`,
              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: `This field can maximum be of ${props.data.max_length} characters`,
              }
            })
          }

          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "",
            }
          })
        }
      }
      if(journeyState?.corpDiscOpt){
        console.log('enterrrrrrr');
      }
      if (props.data.regex) {
        // console.log(target.value,'enterrrrr');
        console.log(props);
        let regex = props.data.regex.toString()
        let rg = regex.substring(1, regex.lastIndexOf("/"))
        let flags = regex.substring(regex.lastIndexOf("/") + 1)
        let regex_exp = new RegExp(rg, flags)
        if (journeyState.corpDiscOpt === "Y" && journeyState.otpVerified === "N"
          && props.data.formControlKey === "corpEmail"
          && ((props.sectionId === "CPPersonalDetailsSection"
          && props.pageId === "PageISelect360CalculatePremium") || (props.sectionId === "sectionYoungTermPersonalDetailsSection"
          && props.pageId === "PageYoungTermCalculatePremium"))
          ){
          let businessUrl = target.value.split('@');
          let domainValue = false
          let emailValue = false
          
          // Check if email domain is in allowed domains
          if(journeyState.corpDiscDomains && journeyState.corpDiscDomains.length){
            domainValue = journeyState.corpDiscDomains.includes(businessUrl[1])
          }
          
          // Check if exact email is in whitelist emails (case-insensitive)
          if (journeyState.corpDiscEmails && journeyState.corpDiscEmails.length) {
            emailValue = journeyState.corpDiscEmails
              .some(email => email.toLowerCase() === target.value.toLowerCase());
          }

          if (domainValue || emailValue) {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data.formControlKey]: "",
              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: `Please enter valid ${lineCapital(getValueFromLookup("label",props.data.label)) || props.data.label}`,
              }
            })
            setShowLocalError(true)
            return
          }
        }
         if (regex_exp.test(target.value)) {
          console.log(journeyState.corpDiscOpt,'normal');
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "",
            }
          })
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: `Please enter valid ${lineCapital(getValueFromLookup(
                  "label",
                  props.data.label
                )) || props.data.label}`,
            
            }
          })
          setShowLocalError(true)
          return
        }
      }

      if(target.value){
        let pattern = /[\<\>\[\{\]\}\^\?\(\)]/
        let n = pattern.test(target.value.toString())
        if(n  && !(props.data.formControlKey === "bankBranchName" || props.data.formControlKey === "bankName")){
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: `Please enter valid ${lineCapital(getValueFromLookup(
                "label",
                props.data.label
              )) || props.data.label}`,
            }
          })
          setShowLocalError(true)
        }
      }

    } else {
      setErrorState(prev => {
        return {
          ...prev,
          [props.data.formControlKey]: "",
        }
      })
    }
    return
  }

  const checkForIfscCodes = (target) => {
    // if (journeyState?.journeyData[0]?.pageData[1]?.sectionData?.GOPAcountry == "AE") return;
    if (props.data.formControlKey.toLowerCase().includes("ifsccode") && (target.value && target.value.length === 11)) {
      let payload = {
        "MIR-BNK-IFSC-CD": target.value
      }
      ifscCodeDetails(payload)
        .then(res => {
          console.log(res.data)
          if (res?.data?.allUniqueBankName) {
            let bankNameList = res?.data?.allUniqueBankName
            let bankName = []
            bankName.push(bankNameList)
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "AppointeeDetailSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "AppointeeBankDetailsTermPlan")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            // setSectionState(prev => {
            //   return ({
            //     ...prev,
            //     sectionData: {
            //       ...prev.sectionData,
            //       bankName: res?.data?.callFlowResponse?.IfscDetails?.Tablerecord?.record?.['MIR-BNK-NM-T'],
            //       bankBranchName: res?.data?.callFlowResponse?.IfscDetails?.Tablerecord?.record?.['MIR-BNK-BR-NM-T']
            //     }
            //   })
            // })
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
            if (Object.keys(bankNameList)?.length === 1) {
              let bank = Object.keys(bankNameList)[0]
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    bankName: bank
                  }
                })
              })
              let bankAddressList = res?.data?.bankAddress?.[bank]
              let bankAddress = []
              bankAddress.push(bankAddressList)
              let temp = journeyState.journeySteps
              let tempPageIndexToChange
              let tempSectionIndexToChange
              let tempComponentGroupIndexToChange
              let tempComponentIndexToChange
              tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
              tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "AppointeeDetailSection")
              tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "AppointeeBankDetailsTermPlan")
              tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchName")
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankAddress
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
              setJourneyState(prev => {
                return ({
                  ...prev,
                  journeySteps: temp
                })
              })
              if (Object.keys(bankAddressList)?.length === 1) {
                let bank = Object.keys(bankAddressList)[0]
                setSectionState(prev => {
                  return ({
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      bankBranchName: bank
                    }
                  })
                })
              }
            }
          } else {
            let bankName = lookup["bankName"]
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "AppointeeDetailSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "AppointeeBankDetailsTermPlan")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true

            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "bankBranchName")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  bankName: "",
                  bankBranchName: ""
                }
              })
            })
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        })
        .catch((err) => {
          console.log("please enter valid ifsc code", err);
        })
    }
  }
  useEffect(() => {
    if(sectionState.sectionData?.[props.data.formControlKey]){
      dataMask({
        value: sectionState.sectionData?.[props.data.formControlKey] ?? "",
      },"mask")
    }
  },[sectionState?.sectionFirstPass, sectionState?.sectionId])

  useEffect(() => {
    validate({
      value: sectionState.sectionData?.[props.data.formControlKey] ?? "",
    })
  }, [sectionState.sectionData?.[props.data.formControlKey]])

  useEffect(() => {
    if(sectionState?.sectionData?.["aadharNumber"] && props.sectionId === "residenceDetailsSection" ){
      let temp = journeyState?.journeySteps
        let tempPageIndexToChange
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "aadharNumber")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "aadharNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
    }
    if(sectionState?.sectionData?.["communicationAadharNumber"] && props.sectionId === "residenceDetailsSection" ){
      let temp = journeyState?.journeySteps
        let tempPageIndexToChange
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "communicationAadharNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
    }
  }, [sectionState?.sectionData])

  useEffect(() => {
    let currentSectionDataInPageState = pageState.pageData.filter(element => {
      return element.sectionId === props.sectionId
    })
    let formControlKeyPresentInPageState = currentSectionDataInPageState?.[0]?.sectionData?.[props.data.formControlKey]
    if (!(sectionState.sectionData?.[props.data.formControlKey] || formControlKeyPresentInPageState)) {
      if (props?.data?.defaultValue) {
        setSectionState(prev => {
          return {
            ...prev,

            sectionData: {
              ...prev.sectionData,

              [props.data.formControlKey]: props.data.defaultValue,
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props
              .data.defaultValue,
          }
        })
        validate(props.data.defaultValue)
        checkForAnnualIncome()
        if(props.saveApplicationAndCallBi)
        props.saveApplicationAndCallBi(props.data.formControlKey,props.data.defaultValue)
      }
    }

  }, [props.sectionId])

  useEffect(() => {
    if(props.journeyIdFromStrapi === "ISelect360Journey" && props.sectionId === "CPPersonalDetailsSection" && props?.data?.formControlKey === "AnnualIncome" && sectionState.sectionData?.[props.data.formControlKey]){
      checkForAnnualIncome()
    } else  if(props.journeyIdFromStrapi === "youngTermPlanJourney" && props.sectionId === "sectionYoungTermPersonalDetailsSection" && props?.data?.formControlKey === "AnnualIncome" && sectionState.sectionData?.[props.data.formControlKey]){
      checkForAnnualIncome()
    }

  }, [sectionState.sectionData && sectionState.sectionData["contactCountryCode"]])

  // useEffect(() => {
  //   console.log(props, "componenttextstring")
  //   if(props.data?.businessRuleCheck){
  //     props.businessRule(props.data.formControlKey)
  //   }
  // }, [sectionState.sectionData?.[props.data.formControlKey]])

  useEffect(() => {
    if(props.journeyIdFromStrapi === "ISelect360Journey" && props.sectionId === "iSelect360CPSpouseCoverDetails" && props?.data?.formControlKey === "spouseAnnualIncome" && sectionState.sectionData?.[props.data.formControlKey]){
      checkForAnnualIncome()
    }else  if(props.journeyIdFromStrapi === "youngTermPlanJourney" && props.sectionId === "youngTermCPSpouseCoverDetails" && props?.data?.formControlKey === "spouseAnnualIncome" && sectionState.sectionData?.[props.data.formControlKey]){
      checkForAnnualIncome()
    }

  }, [sectionState.sectionData && sectionState.sectionData["residentStatus"]])

  const handleChange = ({ target }) => {
    if (
      numToWordFormControlKey.includes(props.data.formControlKey) ||
      props.data.formControlKey.toLowerCase().includes("sumassured")
    ) {
      let regex = new RegExp(/^\d+$/)
      if (regex.test(target.value.replace(/,/g, ""))) {
        let temp = target.value.split(",")
        target.value = temp.join("")
        // target.value = target.value.replaceAll(",", "")
      } else if (target.value == "") {
        target.value = ""
      } else {
        return
      }
    }

    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: props.data.showInCaps ? target.value && target.value?.toUpperCase() : 
            props.data.showInLowerCase ? target.value && target.value?.toLowerCase() :wordCapital(target.value ?? ""),
            [props.data.maskedKey]: props.data.showInCaps ? target.value && target.value?.toUpperCase() : 
            props.data.showInLowerCase ? target.value && target.value?.toLowerCase() :wordCapital(target.value ?? ""),
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: props.data.showInCaps ? target.value && target.value?.toUpperCase() : 
            props.data.showInLowerCase ? target.value && target.value?.toLowerCase() :wordCapital(target.value ?? ""),
            [props.data.maskedKey]: props.data.showInCaps ? target.value && target.value?.toUpperCase() : 
            props.data.showInLowerCase ? target.value && target.value?.toLowerCase() :wordCapital(target.value ?? ""),
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.showInCaps ? target.value && target.value?.toUpperCase() :
        props.data.showInLowerCase ? target.value && target.value?.toLowerCase() : target.value,
      }
    })
    validate(target)
    //console.log(sectionState, "section state")
  }

  const checkForAnnualIncome = () => {
    if (props?.data?.formControlKey === "AnnualIncome" &&
      sectionState.sectionData?.[props.data.formControlKey]) {
      if(props.journeyIdFromStrapi === "iSelectJourney" || props.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney"){
        if(sectionState.sectionData?.[props.data.formControlKey] < 250000){
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`,
            }
          })
          return
        }
      }
      // else if(props.journeyIdFromStrapi === "ISelect360Journey"){
      //   if(sectionState.sectionData["contactCountryCode"] && sectionState.sectionData["contactCountryCode"] !== "+91"){
      //     if(sectionState.sectionData?.[props.data.formControlKey] < 1000000){
      //       setErrorState(prev => {
      //         return {
      //         ...prev,
      //           [props.data.formControlKey]: `This option is not available for this plan`,
      //         }
      //       })
      //       return
      //     }
      //   }else if(sectionState.sectionData["contactCountryCode"] && sectionState.sectionData["contactCountryCode"] === "+91"){
      //     if(sectionState.sectionData?.[props.data.formControlKey] < 250000){
      //       setErrorState(prev => {
      //         return {
      //         ...prev,
      //           [props.data.formControlKey]: `This option is not available for this plan`,
      //         }
      //       })
      //       return
      //     }else{
      //       setErrorState(prev => {
      //         return {
      //         ...prev,
      //           [props.data.formControlKey]: "",
      //         }
      //       })
      //       return
      //     }
      //   }
      // }
    }
    else if(props?.data?.formControlKey === "spouseAnnualIncome" &&
    sectionState.sectionData?.[props.data.formControlKey]){
      if(sectionState.sectionData["residentStatus"] && sectionState.sectionData["residentStatus"] !== "N"){
        if(sectionState.sectionData?.[props.data.formControlKey] < 1000000){
          setErrorState(prev => {
            return {
            ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`,
            }
          })
          return
        }
      }else if(sectionState.sectionData["residentStatus"] && sectionState.sectionData["residentStatus"] === "N"){
        if(sectionState.sectionData?.[props.data.formControlKey] < 250000){
          setErrorState(prev => {
            return {
            ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`,
            }
          })
          return
        }else{
          setErrorState(prev => {
            return {
            ...prev,
              [props.data.formControlKey]: "",
            }
          })
          return
        }
      }
    }
  }

  const checkSameEmail = (target) => {
    if(props.data.formControlKey.toLowerCase().includes("corpemail") && (props.sectionId === "CPPersonalDetailsSection" && props.sectionId === "sectionYoungTermPersonalDetailsSection")){
      if(target.value.toLowerCase() === sectionState.sectionData["email"].toLowerCase()){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Corporate Email id and Personal Email id cannot be same"
          })
        })
      }else {
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
  }

  const aadharMask = (target, name) => {
    if(props.data.formControlKey === "aadharNumber" && props.sectionId === "residenceDetailsSection" && !errorState["aadharNumber"]){
      if(name === "mask"){
      if(target.value.length === 12 || target.value.length === 16){
        let aadharNumber = target.value
        let mask = target.value.slice(8)
        let maskAdharValue = `XXXXXXXX${mask}`
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "aadharNumber")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "aadharNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: maskAdharValue,
              ["aadharNumberValueCurrent"]: aadharNumber
            }
          })
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        }
      } else {
        let aadharNumberValue
        if(sectionState.sectionData["aadharNumber"] === ""){
           aadharNumberValue = ""
        } else{
            aadharNumberValue = sectionState.sectionData["aadharNumberValueCurrent"] || target.value
            let temp = journeyState?.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "aadharNumber")
            let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "aadharNumber")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/(^[0-9]{12}$)/"
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: aadharNumberValue,
                  ["aadharNumberValueCurrent"]: aadharNumberValue
                }
              })
            })
          }
      }
    }
    if(props.data.formControlKey === "communicationAadharNumber" && props.sectionId === "residenceDetailsSection" && !errorState["communicationAadharNumber"]){
      if(name === "mask"){
      if(target.value.length === 12 || target.value.length === 16){
        let aadharNumber = target.value
        let mask = target.value.slice(8)
        let maskAdharValue = `XXXXXXXX${mask}`
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "communicationAadharNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: maskAdharValue,
              ["aadharNumberValuePermanent"]: aadharNumber
            }
          })
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        }
      } else {
        let aadharNumberValue
        if(sectionState.sectionData["communicationAadharNumber"] === ""){
           aadharNumberValue = ""
        } else{
            aadharNumberValue = sectionState.sectionData["aadharNumberValuePermanent"] || target.value
            let temp = journeyState?.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
            let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "communicationAadharNumber")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/(^[0-9]{12}$)/"
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: aadharNumberValue,
                  ["aadharNumberValuePermanent"]: aadharNumberValue
                }
              })
            })
          }
      }
    }
  }

  const dataMask = (target, name) => {
      let maskValue
      if(name === "mask" && target.value){
        if(numToWordFormControlKey.includes(props.data.formControlKey) ||
        props.data.formControlKey.toLowerCase().includes("sumassured"))(
          setShowIns(false)
        )
        if(props.data.maskType === "string"){
          maskValue = target.value.slice(0, 5) + "*****" 
          setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.maskedKey]: maskValue
            }
          })
        })
        } else if(props.data.maskType === "email"){
          maskValue = maskAlternateCharsInEmail(target.value)
          setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.maskedKey]: maskValue
            }
          })
        })
        } else if(props.data.maskType === "number"){
          let mask = target.value.slice(0,5)
          maskValue = `${mask}XXXXX`
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.maskedKey]: maskValue
              }
            })
          })
        }
      } else {
        setShowIns(true)
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.maskedKey]: sectionState?.sectionData[props.data.formControlKey],
                }
              })
            })
          }

  }

  // for la terminal ilness cover
  useEffect(() => {
    // this useEffect is for setting the sumAssuredTIC value to 2cr if the sumAssured value is greater than 2cr
    // and if base sum assured is less than 2 cr then sumAssuredTIC should be equal to base sum assured
    // the field is already disabled via journeyssr
    if (props.data.formControlKey === "iS360sumAssuredTIC"){
      const baseSumAssured = Number(conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanSumAssured"])
      let terminaIlnessCover = baseSumAssured
      if (baseSumAssured > 20000000){
        terminaIlnessCover = 20000000
      }
      setSectionState(prev => {
        return {
          ...prev, 
          sectionData : {
            ...prev.sectionData,
            iS360sumAssuredTIC: terminaIlnessCover
          }
        }
      })
      props.saveApplicationAndCallBi(
        props.data.formControlKey,
        terminaIlnessCover
      )
    }
  }, [])


  // for spouse Terminal ilness cover
  useEffect(() => {
    if (props.data.formControlKey === "iS360SpouseSumAssuredTIC"){
      const spouseBaseSumAssured = Number(conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.sumAssured"])
      let terminaIlnessCover = spouseBaseSumAssured
      if (spouseBaseSumAssured > 20000000){
        terminaIlnessCover = 20000000
      }
      setSectionState(prev => {
        return {
          ...prev, 
          sectionData : {
            ...prev.sectionData,
            iS360SpouseSumAssuredTIC: terminaIlnessCover
          }
        }
      })
      props.saveApplicationAndCallBi(
        props.data.formControlKey,
        terminaIlnessCover
      )
    }
  }, [sectionState.sectionData["sumAssured"]])
  

  return (
    <>
      <InputContainer
        channel={props.channel}
        className={`form-group input-container ${
          props.data.disabled ? "disable-input" : ""
        }
        ${
          props.data.html ? "input-auto-height":""
        }`}
      >
        <label
          className={`input-label ${props.data.label ? "" : "no-label"} `}
          htmlFor={props.data.id ? props.data.id : props.data.label}
          > { (journeyState.corpDiscOpt === "Y" && props.data.formControlKey === "email") 
          ? "Personal email ID"
          : (getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}
        </label>
        <div className="form-control str-input">
          <input
            type="text"
            style={{
              width:
                numToWordFormControlKey.includes(props.data.formControlKey) ||
                props.data.formControlKey.toLowerCase().includes("sumassured")
                  ? "60%"
                  : "100%",
            }}
            autoComplete="new-password"
            name={props.data.name}
            required={props.data.required}
            placeholder={(getValueFromLookup(
              "placeholder",
              props.data.placeholder
            )) || props.data.placeholder}
            disabled={props.data.disabled}
            id={props.data.id ? props.data.id : props.data.label}
            onChange={handleChange}
            onClick={e => {
              aadharMask(e.target, "nonMask")
              props.data.isMasked && dataMask(e.target,"nonMask")
          }}
            value={
              props.data.isMasked ? sectionState.sectionData?.[props.data.maskedKey]
              : sectionState.sectionData?.[props.data.formControlKey]
                ? numToWordFormControlKey.includes(props.data.formControlKey)
                  ? applyComma(
                      sectionState.sectionData[props.data.formControlKey]
                    )
                  : sectionState.sectionData[props.data.formControlKey]
                : ""
            }
            onBlur={e => {
              checkForIfscCodes(e.target)
              validate(e.target)
              aadharMask(e.target, "mask")
              checkForAnnualIncome()
              checkSameEmail(e.target)
              props.saveApplicationAndCallBi &&
                props.saveApplicationAndCallBi(
                  props.data.formControlKey,
                  e.target.value
                )
                props.data?.businessRuleCheck && props.businessRule(props.data.formControlKey)
                props.data.isMasked && dataMask(e.target,"mask")
            }}
          />
          <span
            style={{
              fontSize: "10px",
            }}
          >
            {numToWordFormControlKey.includes(props.data.formControlKey) ||
            props.data.formControlKey.toLowerCase().includes("sumassured")
              ? showIns ? insWords(sectionState.sectionData?.[props.data.formControlKey])
              : null : null}
          </span>
        </div>
        <span className="input-error">
          {(props.showError || showLocalError) &&
            errorState[props.data.formControlKey]}
        </span>
        <div dangerouslySetInnerHTML={{ __html: props.data.html}} ></div>
      </InputContainer>
    </>
  )
}